/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Cloudflare_LabelInputs */



/**
* | output |
* | --- |
* | "Cloudflare Stream URL or Video ID" |
*
* @param {Media_Import_Cloudflare_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_cloudflare_label = /** @type {((inputs?: Media_Import_Cloudflare_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Cloudflare_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL Cloudflare Stream ou ID vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloudflare-Stream-URL oder Video-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL Cloudflare Stream o ID video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL Cloudflare Stream или ID видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de Cloudflare Stream o ID de video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cloudflare Stream URL 或视频 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cloudflare Stream URLまたは動画ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cloudflare Stream URL या वीडियो ID")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do Cloudflare Stream ou ID do vídeo")
	return /** @type {LocalizedString} */ ("Cloudflare Stream URL or Video ID")
});